import { Component, OnInit,Input, Output,EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CompararService } from '../../../../services/general/comparar.service';
import { Subscription } from 'rxjs/Subscription';
import {Observable} from 'rxjs/Observable';

declare var jquery:any;
declare var $ :any;

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.css']
})


export class NotificationComponent implements OnInit {



  @Input('titulo') titulo;
  @Input('mensaje') mensaje;
  @Input('ruta') ruta;


  // Usamos el decorador Output
  @Output() comprarPoliza = new EventEmitter();

  constructor(private route: ActivatedRoute,private router: Router) { }

  ngOnInit() {
  }

  salir(){
       $('#modalNotif').modal('hide');
      if(this.ruta!=""){
       this.router.navigate([this.ruta]);
      }
   }




}



// WEBPACK FOOTER //
// ./src/app/components/general/modals/notification/notification.component.ts